(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[62487],{

/***/ 19582:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uganda",
      function () {
        return __webpack_require__(79324);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Accounts"
}); /*END_META*/ 


/***/ }),

/***/ 90986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Adding Custom Styles"
}); /*END_META*/ 


/***/ }),

/***/ 48317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "App customisation"
}); /*END_META*/ 


/***/ }),

/***/ 11260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Features available in tradly apps"
}); /*END_META*/ 


/***/ }),

/***/ 35773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Appstore Setup"
}); /*END_META*/ 


/***/ }),

/***/ 25192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Attributes"
}); /*END_META*/ 


/***/ }),

/***/ 38430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Auth Systems"
}); /*END_META*/ 


/***/ }),

/***/ 56400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Branch Metrics"
}); /*END_META*/ 


/***/ }),

/***/ 94485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{}); /*END_META*/ 


/***/ }),

/***/ 31910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Category"
}); /*END_META*/ 


/***/ }),

/***/ 87630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "In-built Chat"
}); /*END_META*/ 


/***/ }),

/***/ 63113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Launch Checklist"
}); /*END_META*/ 


/***/ }),

/***/ 26716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Deploying web apps in Cloudflare"
}); /*END_META*/ 


/***/ }),

/***/ 49128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Collections"
}); /*END_META*/ 


/***/ }),

/***/ 83544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Core Concepts"
}); /*END_META*/ 


/***/ }),

/***/ 67221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Commission"
}); /*END_META*/ 


/***/ }),

/***/ 68939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Composer"
}); /*END_META*/ 


/***/ }),

/***/ 7000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Coupon"
}); /*END_META*/ 


/***/ }),

/***/ 37177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Crowdfunding"
}); /*END_META*/ 


/***/ }),

/***/ 37607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Multi Currencies"
}); /*END_META*/ 


/***/ }),

/***/ 48576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Deeplinks"
}); /*END_META*/ 


/***/ }),

/***/ 38819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Delivery Methods"
}); /*END_META*/ 


/***/ }),

/***/ 80390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Checklist"
}); /*END_META*/ 


/***/ }),

/***/ 61798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Domain Setup"
}); /*END_META*/ 


/***/ }),

/***/ 56331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Creating Dynamic Pages"
}); /*END_META*/ 


/***/ }),

/***/ 77659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Editing Page Styles in Tradly"
}); /*END_META*/ 


/***/ }),

/***/ 60285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Editor Basic Overview"
}); /*END_META*/ 


/***/ }),

/***/ 75562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Solving Education"
}); /*END_META*/ 


/***/ }),

/***/ 14095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Email Setup"
}); /*END_META*/ 


/***/ }),

/***/ 37816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Discovery / Mobility Solutions"
}); /*END_META*/ 


/***/ }),

/***/ 21918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Facebook App"
}); /*END_META*/ 


/***/ }),

/***/ 9793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Firebase"
}); /*END_META*/ 


/***/ }),

/***/ 30531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Food Ecosystem"
}); /*END_META*/ 


/***/ }),

/***/ 96569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Google Analytics"
}); /*END_META*/ 


/***/ }),

/***/ 76536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Google Maps"
}); /*END_META*/ 


/***/ }),

/***/ 93959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Growth Checklist"
}); /*END_META*/ 


/***/ }),

/***/ 62951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Integrations FAQ"
}); /*END_META*/ 


/***/ }),

/***/ 89182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Inventory / Stocks"
}); /*END_META*/ 


/***/ }),

/***/ 77992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Signing up for Karix and Using as SMS gateway"
}); /*END_META*/ 


/***/ }),

/***/ 89406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Multi Language"
}); /*END_META*/ 


/***/ }),

/***/ 11866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Listings"
}); /*END_META*/ 


/***/ }),

/***/ 26787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Geo Location"
}); /*END_META*/ 


/***/ }),

/***/ 94691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "MangoPay"
}); /*END_META*/ 


/***/ }),

/***/ 79297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Media"
}); /*END_META*/ 


/***/ }),

/***/ 30293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Setting Up Negotiations"
}); /*END_META*/ 


/***/ }),

/***/ 53165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Netlify"
}); /*END_META*/ 


/***/ }),

/***/ 33775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Notifications"
}); /*END_META*/ 


/***/ }),

/***/ 84096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Online Payment Platform"
}); /*END_META*/ 


/***/ }),

/***/ 24521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Order & Checkout Methods"
}); /*END_META*/ 


/***/ }),

/***/ 11906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Solutions Ideas"
}); /*END_META*/ 


/***/ }),

/***/ 64811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": 'PayDunya"'
}); /*END_META*/ 


/***/ }),

/***/ 30688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Payment Methods"
}); /*END_META*/ 


/***/ }),

/***/ 41394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Playstore Setup"
}); /*END_META*/ 


/***/ }),

/***/ 19904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Different Products"
}); /*END_META*/ 


/***/ }),

/***/ 38345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Promotion"
}); /*END_META*/ 


/***/ }),

/***/ 61582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Q&A - Comments"
}); /*END_META*/ 


/***/ }),

/***/ 97405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Razorpay"
}); /*END_META*/ 


/***/ }),

/***/ 86580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Deploying web apps in Render"
}); /*END_META*/ 


/***/ }),

/***/ 79248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Analytics Features"
}); /*END_META*/ 


/***/ }),

/***/ 63676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Revenue Model"
}); /*END_META*/ 


/***/ }),

/***/ 84053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Review and Ratings"
}); /*END_META*/ 


/***/ }),

/***/ 93118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Booking Schedules"
}); /*END_META*/ 


/***/ }),

/***/ 5586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Customizing Screens",
    "shortTitle": "Screens"
}); /*END_META*/ 


/***/ }),

/***/ 78533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Search & Filters"
}); /*END_META*/ 


/***/ }),

/***/ 12137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "SEO"
}); /*END_META*/ 


/***/ }),

/***/ 28309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Checklist for Mobile Apps"
}); /*END_META*/ 


/***/ }),

/***/ 23344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Social Feed"
}); /*END_META*/ 


/***/ }),

/***/ 92647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Stripe Connect"
}); /*END_META*/ 


/***/ }),

/***/ 16764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Stripe Onboarding"
}); /*END_META*/ 


/***/ }),

/***/ 53402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Stripe Payments"
}); /*END_META*/ 


/***/ }),

/***/ 6882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Stuart Delivery"
}); /*END_META*/ 


/***/ }),

/***/ 75493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Submitting Template to the Tradly Marketplace"
}); /*END_META*/ 


/***/ }),

/***/ 69764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Subscription revenue model"
}); /*END_META*/ 


/***/ }),

/***/ 40409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{}); /*END_META*/ 


/***/ }),

/***/ 27763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Taxation"
}); /*END_META*/ 


/***/ }),

/***/ 25013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Template Creation"
}); /*END_META*/ 


/***/ }),

/***/ 48315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Test Apps"
}); /*END_META*/ 


/***/ }),

/***/ 78001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Custom Event Tracking"
}); /*END_META*/ 


/***/ }),

/***/ 22339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Translations"
}); /*END_META*/ 


/***/ }),

/***/ 65268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Signing up for Twilio and Using as SMS gateway"
}); /*END_META*/ 


/***/ }),

/***/ 12464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Users"
}); /*END_META*/ 


/***/ }),

/***/ 65949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Variants"
}); /*END_META*/ 


/***/ }),

/***/ 75005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Vercel Deployment"
}); /*END_META*/ 


/***/ }),

/***/ 99097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Account Wallet"
}); /*END_META*/ 


/***/ }),

/***/ 44717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Webhook"
}); /*END_META*/ 


/***/ }),

/***/ 67419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Things to setup in your website"
}); /*END_META*/ 


/***/ }),

/***/ 56012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Wishlist"
}); /*END_META*/ 


/***/ }),

/***/ 72957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Zapier"
}); /*END_META*/ 


/***/ }),

/***/ 71871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);



/* @jsxRuntime classic */ /* @jsx mdx */ 

var meta = {};
var slug = "_advancedfeatures";
var tableOfContents = [
    {
        "title": "------",
        "slug": "",
        "children": [
            {
                "title": "Product Collection",
                "slug": "product-collection",
                "children": []
            },
            {
                "title": "Taxes (Advanced)",
                "slug": "taxes-advanced",
                "children": []
            },
            {
                "title": "Product Types",
                "slug": "product-types",
                "children": []
            },
            {
                "title": "Advanced Rules",
                "slug": "advanced-rules",
                "children": []
            },
            {
                "title": "Custom Fields (Attributes) for Product descriptions & Filters",
                "slug": "custom-fields-attributes-for-product-descriptions-and-filters",
                "children": []
            },
            {
                "title": "Monitoring Business",
                "slug": "monitoring-business",
                "children": []
            }
        ]
    }
];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "",
        nextElement: {
            "type": "heading",
            "depth": 3
        }
    }, "------"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "product-collection",
        nextElement: {
            "type": "paragraph"
        }
    }, "Product Collection"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Organise your products into collections (Thematic, promotional, season etc) "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/collection.png"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "taxes-advanced",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "Taxes (Advanced)"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Discounts"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Mini-tools (QR Code Generator, Barcode Generator, Short Link generator, UTM Generator) ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "product-types",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "Product Types"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Items with Variances"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Items with Bundles\nRead more about Variation Here. ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/variants1.png"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "advanced-rules",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "Advanced Rules"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Limit number of items purchased on platform level (Stocks, Ticket Limits)"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Limit number of items purchased per user "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Limit Minimum Price, Minimum Quantity, Maximum Quantity "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Limit minimum total order size on Payment method level ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Read more about how to use this rules here"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Learn more about shipping methods. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "custom-fields-attributes-for-product-descriptions-and-filters",
        nextElement: {
            "type": "paragraph"
        }
    }, "Custom Fields (Attributes) for Product descriptions & Filters"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "You can easily add custom fields for your product adding page. And it can be customised to be shown on listing category level. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/attributes2.png"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/docs/attributes",
        passHref: true
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", null, "Learn more about here"))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "monitoring-business",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "Monitoring Business"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Inventory report"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Sales report")));
}
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps;


/***/ }),

/***/ 57796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);



/* @jsxRuntime classic */ /* @jsx mdx */ 

var meta = {};
var slug = "_growingstore";
var tableOfContents = [
    {
        "title": "------",
        "slug": "",
        "children": [
            {
                "title": "SEO",
                "slug": "seo",
                "children": []
            },
            {
                "title": "Email Tools",
                "slug": "email-tools",
                "children": []
            },
            {
                "title": "Advertising Tools",
                "slug": "advertising-tools",
                "children": []
            },
            {
                "title": "Analytical Tools",
                "slug": "analytical-tools",
                "children": []
            },
            {
                "title": "Feedback & Survey Tools",
                "slug": "feedback-and-survey-tools",
                "children": []
            },
            {
                "title": "Promotion / Popup tools",
                "slug": "promotion-popup-tools",
                "children": []
            }
        ]
    }
];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "",
        nextElement: {
            "type": "paragraph"
        }
    }, "------"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "On top of Tradly Free Creator tools. You can add 3rd party apps inside your store for further faetures. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/webintegrations.png"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "seo",
        nextElement: {
            "type": "paragraph"
        }
    }, "SEO"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "SEO (Structured card image) & Search engine listing preview, "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "email-tools",
        nextElement: {
            "type": "paragraph"
        }
    }, "Email Tools"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Integrating your online store with Marketing Tools (especially Mailchimp for emails) "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "advertising-tools",
        nextElement: {
            "type": "paragraph"
        }
    }, "Advertising Tools"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Your hosted website can add integrations to run ads. Example: Facebook Pixel, Google Ads Conversion Pixel can be added through Native integrations. or you can use Google Tag Manager integration to do advanced pixel placement in specific pages or custom trigger condition. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "analytical-tools",
        nextElement: {
            "type": "paragraph"
        }
    }, "Analytical Tools"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Connect with Analytical Tools (like Google Analytics) "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "feedback-and-survey-tools",
        nextElement: {
            "type": "paragraph"
        }
    }, "Feedback & Survey Tools"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Connecting with Feedback & UX monitoring tools (like Hotjar, clarity) (By default, we have feedback form) "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "promotion-popup-tools",
        nextElement: {
            "type": "paragraph"
        }
    }, "Promotion / Popup tools"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Connecting Promotion / Popup tools"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Advanced Growth Tactics"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Increase AOV by setting up minimum purchase "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Create Collection pages to get more exposure in Google Search results or thematic celebrations. ")));
}
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps;


/***/ }),

/***/ 68707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);



/* @jsxRuntime classic */ /* @jsx mdx */ 

var meta = {};
var slug = "_scaling";
var tableOfContents = [
    {
        "title": "------",
        "slug": "",
        "children": []
    }
];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "",
        nextElement: {
            "type": "paragraph"
        }
    }, "------"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Established and looking to expand & Scale? "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Fleet Management System to manage your own deliveries thus reducing cost and providing end-to-end delightful experience for your customers"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Mobile Apps for your customers, so they can be in touch with you everyday "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Additional Integrations on backend level (Via API and Webhooks) to support with your internal systems")));
}
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps;


/***/ }),

/***/ 15872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);



/* @jsxRuntime classic */ /* @jsx mdx */ 

var meta = {};
var slug = "_settingup";
var tableOfContents = [
    {
        "title": "------",
        "slug": "",
        "children": [
            {
                "title": "Add Products",
                "slug": "add-products",
                "children": []
            },
            {
                "title": "Activate Payment gateways",
                "slug": "activate-payment-gateways",
                "children": []
            },
            {
                "title": "Activate Shipment options",
                "slug": "activate-shipment-options",
                "children": []
            },
            {
                "title": "Add your custom domain",
                "slug": "add-your-custom-domain",
                "children": []
            }
        ]
    }
];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "",
        nextElement: {
            "type": "heading",
            "depth": 3
        }
    }, "------"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "add-products",
        nextElement: {
            "type": "paragraph"
        }
    }, "Add Products"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Write your product title and description. Upload product photos or other media. Set your price, Setup Stocks limit."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/add-product-store.png"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "activate-payment-gateways",
        nextElement: {
            "type": "paragraph"
        }
    }, "Activate Payment gateways"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "We support multiple payment gateways. If you are interested in implementing a custom payment gateways, let us know in the contact form."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/payment-store.png"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "activate-shipment-options",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "Activate Shipment options"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Pick up at source ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Delivery/Pick up at Storage Points ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Delivery at Destination ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Delivery "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/shipping-store.png"
    })))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "add-your-custom-domain",
        nextElement: {
            "type": "jsx"
        }
    }, "Add your custom domain"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/customdomain-store.png"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Your store is ready to start making money \uD83D\uDE80"));
}
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps;


/***/ }),

/***/ 23573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);



/* @jsxRuntime classic */ /* @jsx mdx */ 

var meta = {};
var slug = "_storecustomisation";
var tableOfContents = [
    {
        "title": "------",
        "slug": "",
        "children": [
            {
                "title": "Branding",
                "slug": "branding",
                "children": []
            },
            {
                "title": "Pages",
                "slug": "pages",
                "children": []
            }
        ]
    }
];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "",
        nextElement: {
            "type": "paragraph"
        }
    }, "------"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "For a start, get started with a simple one, so you can focus on important aspects of the business. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "branding",
        nextElement: {
            "type": "paragraph"
        }
    }, "Branding"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Add your branding (Set your colours, typography, and other theme settings)"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/customisation-store.png"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "pages",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "Pages"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Business crucial pages like about us, FAQ, Privacy, Terms, contact us page, etc can be created")));
}
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps;


/***/ }),

/***/ 79324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _store_settingup_mdx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15872);
/* harmony import */ var _store_storecustomisation_mdx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23573);
/* harmony import */ var _store_advancedfeatures_mdx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71871);
/* harmony import */ var _store_growingstore_mdx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57796);
/* harmony import */ var _store_scaling_mdx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68707);
/* harmony import */ var _Shared_TemplatesCard__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85227);



/* @jsxRuntime classic */ /* @jsx mdx */ 







var Layout = (__webpack_require__(7346)/* .RootFileLayout */ .k);
var meta = {
    "title": "Free Online Store Builder: How to Launch Online Store & Marketplaces in Uganda - 2024",
    "date": "2024-10-28",
    "meta_description": "Launch in Uganda online store with Tradly's amazingly simple no-code Store Creator - Super Simple - Free + multiple tools! "
};
var slug = "uganda";
var tableOfContents = [
    {
        "title": "Why Choose Tradly?",
        "slug": "why-choose-tradly",
        "children": []
    },
    {
        "title": "Payment Gateways For Uganda",
        "slug": "payment-gateways-for-uganda",
        "children": []
    },
    {
        "title": "Register a free account",
        "slug": "register-a-free-account",
        "children": []
    },
    {
        "title": "Setting Up Store",
        "slug": "setting-up-store",
        "children": []
    },
    {
        "title": "Customising Store",
        "slug": "customising-store",
        "children": []
    },
    {
        "title": "Advanced Features",
        "slug": "advanced-features",
        "children": []
    },
    {
        "title": "Growing your Store",
        "slug": "growing-your-store",
        "children": []
    },
    {
        "title": "Scaling your Store",
        "slug": "scaling-your-store",
        "children": []
    }
];
var layoutProps = {
    Layout: Layout,
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = (__webpack_require__(87274)/* .CustomContentsLayout */ .NH);
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Welcome to Tradly, the online toolkit that helps you launch your own e-commerce website or marketplace for selling high-quality products from Uganda to buyers around the world. With our platform, you can create your own professional website or marketplace and start selling directly to customers, cutting out the middlemen and setting your own prices."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "From fresh and frozen fish to ground nuts, coconuts, legumes, melons, soups, broths, and ground nut oil, Sell and showcase the best of Uganda’s agriculture. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/snegal.jpg"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "why-choose-tradly",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": true
        }
    }, "Why Choose Tradly?"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Launch your own website or marketplace: With Tradly, you have all the tools you need to create your own professional website or marketplace for selling products from Uganda. Our platform is easy to use and includes features like product listings, payment processing, and customer management.")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Set your own prices: You are in control of the pricing for your products. You can set prices that reflect the quality of your products and the value you offer to customers.")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Direct sales: By selling directly to customers, you can cut out the middlemen who can drive down prices and take a large percentage of the profits.")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Promote sustainable farming practices: Tradly is committed to promoting sustainable and organic farming practices. We encourage farmers to start building independant business that they can control. ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Help farmers get a fair price for their crops: The low prices that many farmers in Uganda receive for their crops can make it difficult for them to make a living. By launching your own website or marketplace, you can help these farmers get a fair price for their hard work.")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Promote fair trade options: Many farmers in Uganda lack access to fair trade options, which can result in them receiving low prices for their crops. By launching your own website or marketplace with Tradly, you can promote fair trade options and help farmers receive a fair return for their products."))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Join Tradly today and start building your own website or marketplace for selling high-quality products from Uganda to buyers around the world"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "It’s easy to launch your store with Tradly"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Register for free & Pay as you grow"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Customise your template with simple toggle & form based input "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Add Integrations without any code or technical implementations")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "payment-gateways-for-uganda",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "Payment Gateways For Uganda"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Tradly have ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "li"
    }, {
        "href": "https://tradly.app/integrations/pawapay--payment-gateway-for-africa"
    }), "Pawapay Payment Integrations"), " which has connection with Airtel Money, MOMO MTN, etc.")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "register-a-free-account",
        nextElement: {
            "type": "jsx"
        }
    }, "Register a free account"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/signup-tradly.png"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/signup",
        passHref: true
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", null, "Signup"))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_Shared_TemplatesCard__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        category_id: 4283,
        title: "Free Online Store Templates",
        isShowBtn: true,
        mdxType: "TemplatesCards"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "setting-up-store",
        nextElement: {
            "type": "jsx"
        }
    }, "Setting Up Store"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_store_settingup_mdx__WEBPACK_IMPORTED_MODULE_4__["default"], {
        mdxType: "Settingup"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "customising-store",
        nextElement: {
            "type": "jsx"
        }
    }, "Customising Store"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_store_storecustomisation_mdx__WEBPACK_IMPORTED_MODULE_5__["default"], {
        mdxType: "Storecustomisation"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "advanced-features",
        nextElement: {
            "type": "jsx"
        }
    }, "Advanced Features"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_store_advancedfeatures_mdx__WEBPACK_IMPORTED_MODULE_6__["default"], {
        mdxType: "Advancedfeatures"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "growing-your-store",
        nextElement: {
            "type": "jsx"
        }
    }, "Growing your Store"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_store_growingstore_mdx__WEBPACK_IMPORTED_MODULE_7__["default"], {
        mdxType: "Growingstore"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "scaling-your-store",
        nextElement: {
            "type": "jsx"
        }
    }, "Scaling your Store"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_store_scaling_mdx__WEBPACK_IMPORTED_MODULE_8__["default"], {
        mdxType: "Scaling"
    }));
}
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps;


/***/ }),

/***/ 85227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70441);
/* harmony import */ var constant_functions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60538);








var TemplatesCards = function(param) {
    var template_id = param.template_id, category_id = param.category_id, title = param.title, isShowBtn = param.isShowBtn, template_btn_title = param.template_btn_title;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), templates = ref[0], setTemplates = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var params = {
            page: 1
        };
        if (category_id) {
            params.category_id = category_id;
        }
        axios__WEBPACK_IMPORTED_MODULE_1___default().get("/api/all_templates", {
            params: params
        }).then(function(res) {
            setTemplates(res.data.data.listings);
        });
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: " ",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex justify-between items-center my-5 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                        className: "h4 m-0 text-black font-semibold",
                        children: (title === null || title === void 0 ? void 0 : title.length) > 0 && title
                    }),
                    isShowBtn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: {
                            pathname: "/templates"
                        },
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "btn-sm bg-primary hover:bg-transparent text-white hover:text-primary ",
                            children: "See All"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "grid gap-12 md:grid-cols-3 md:gap-x-6 md:gap-y-8 items-start",
                children: templates === null || templates === void 0 ? void 0 : templates.map(function(item) {
                    var Type = function(attributes) {
                        var ref, ref1;
                        return (ref1 = (ref = attributes.filter(function(at) {
                            return at.name === "Type";
                        })[0]) === null || ref === void 0 ? void 0 : ref.values[0]) === null || ref1 === void 0 ? void 0 : ref1.name;
                    };
                    // is_active
                    var is_active = function(attributes) {
                        var ref;
                        return ((ref = attributes.filter(function(at) {
                            return at.name === "Active";
                        })[0]) === null || ref === void 0 ? void 0 : ref.values[0]) == true ? true : undefined;
                    };
                    if ((template_id === null || template_id === void 0 ? void 0 : template_id.length) > 0) {
                        if (template_id.includes(item.id) && is_active(item.attributes)) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col h-full sha rounded-md overflow-hidden border border-[#eaeaea] hover:shadow-medium p-3 transition-all duration-300",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                                        className: "mb-5",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: " w-full h-[200px] block relative mb-5 overflow-hidden ",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    className: "w-full h-full object-cover object-top ",
                                                    src: (0,constant_functions__WEBPACK_IMPORTED_MODULE_6__.getThumbnailImage)(item.images[0]),
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: " px-2 text-xl font-bold leading-snug tracking-tight mt-0 mb-2 text-center",
                                                children: item.title.length > 20 ? item.title.substr(0, 20) + ".." : item.title
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "/templates/".concat(item.slug),
                                            className: "btn w-full bg-primary hover:bg-white text-white hover:text-primary border border-transparent hover:border-primary transition duration-300 ",
                                            onClick: function() {
                                                var _obj;
                                                (0,constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelTracking */ .n5)(constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelEventName.click_template_on_embed */ .aK.click_template_on_embed, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelPropertiesName.referrer */ .Oe.referrer, router.pathname), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelPropertiesName.template_slug */ .Oe.template_slug, item.slug), _obj));
                                            },
                                            children: template_btn_title ? template_btn_title : "GET TEMPLATE"
                                        })
                                    })
                                ]
                            });
                        }
                    } else {
                        if (is_active(item.attributes)) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col h-full sha rounded-md overflow-hidden border border-[#eaeaea] hover:shadow-medium p-3 transition-all duration-300",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                                        className: "mb-5",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: " w-full h-[200px] block relative mb-5 overflow-hidden ",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    className: "w-full h-full object-cover object-top ",
                                                    src: (0,constant_functions__WEBPACK_IMPORTED_MODULE_6__.getThumbnailImage)(item.images[0]),
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: " px-2 text-xl font-bold leading-snug tracking-tight mt-0 mb-2 text-center",
                                                children: item.title.length > 20 ? item.title.substr(0, 20) + ".." : item.title
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "/templates/".concat(item.slug),
                                            className: "btn w-full bg-primary hover:bg-white text-white hover:text-primary border border-transparent hover:border-primary transition duration-300 ",
                                            onClick: function() {
                                                var _obj;
                                                (0,constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelTracking */ .n5)(constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelEventName.click_template_on_embed */ .aK.click_template_on_embed, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelPropertiesName.referrer */ .Oe.referrer, router.pathname), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelPropertiesName.template_slug */ .Oe.template_slug, item.slug), _obj));
                                            },
                                            children: template_btn_title ? template_btn_title : "GET TEMPLATE"
                                        })
                                    })
                                ]
                            });
                        }
                    }
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TemplatesCards);


/***/ }),

/***/ 7346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ RootFileLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/layouts/SidebarLayout.js
var SidebarLayout = __webpack_require__(21744);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/img/tradly/Tradly MEta image.png
var Tradly_MEta_image = __webpack_require__(52066);
// EXTERNAL MODULE: ./src/components/Title.js
var Title = __webpack_require__(68224);
// EXTERNAL MODULE: ./src/navs/documentation.js + 2 modules
var documentation = __webpack_require__(54713);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useIsomorphicLayoutEffect.js
var useIsomorphicLayoutEffect = __webpack_require__(67129);
// EXTERNAL MODULE: ./src/components/Search.js + 2 modules
var Search = __webpack_require__(30112);
;// CONCATENATED MODULE: ./src/layouts/MagazineLayout.js








var SidebarContext = /*#__PURE__*/ (0,react.createContext)();
/**
 * Find the nearst scrollable ancestor (or self if scrollable)
 *
 * Code adapted and simplified from the smoothscroll polyfill
 *
 *
 * @param {Element} el
 */ function nearestScrollableContainer(el) {
    var isScrollable = /**
   * indicates if an element can be scrolled
   *
   * @param {Node} el
   */ function isScrollable(el) {
        var style = window.getComputedStyle(el);
        var overflowX = style["overflowX"];
        var overflowY = style["overflowY"];
        var canScrollY = el.clientHeight < el.scrollHeight;
        var canScrollX = el.clientWidth < el.scrollWidth;
        var isScrollableY = canScrollY && (overflowY === "auto" || overflowY === "scroll");
        var isScrollableX = canScrollX && (overflowX === "auto" || overflowX === "scroll");
        return isScrollableY || isScrollableX;
    };
    while(el !== document.body && isScrollable(el) === false){
        el = (el === null || el === void 0 ? void 0 : el.parentNode) || (el === null || el === void 0 ? void 0 : el.host);
    }
    return el;
}
function Wrapper(param) {
    var allowOverflow = param.allowOverflow, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: allowOverflow ? undefined : "overflow-hidden",
        children: children
    });
}
function MagazineLayout(param) {
    var children = param.children, navIsOpen = param.navIsOpen, setNavIsOpen = param.setNavIsOpen, nav = param.nav, sidebar = param.sidebar, fallbackHref = param.fallbackHref, tmp = param.layoutProps, ref = tmp === void 0 ? {} : tmp, _allowOverflow = ref.allowOverflow, allowOverflow = _allowOverflow === void 0 ? true : _allowOverflow;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarContext.Provider, {
        value: {
            nav: nav,
            navIsOpen: navIsOpen,
            setNavIsOpen: setNavIsOpen
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
            allowOverflow: allowOverflow,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pt-10 ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "",
                    children: children
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/layouts/RootFileLayout.js









function RootFileLayout(props) {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                suffix: router.pathname === "/" ? undefined : "Tradly",
                children: props.layoutProps.meta.metaTitle || props.layoutProps.meta.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }, "twitter:card"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://tradly.app".concat(Tradly_MEta_image/* default */.Z)
                    }, "twitter:image"),
                    props.layoutProps.meta.canonical && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: props.layoutProps.meta.canonical
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineLayout, (0,_object_spread/* default */.Z)({}, props))
        ]
    });
}
RootFileLayout.nav = documentation/* documentationNav */.u;


/***/ }),

/***/ 54713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ documentationNav; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/utils/importAll.js
function importAll(r) {
    return r.keys().map(function(fileName) {
        return {
            fileName: fileName,
            module: r(fileName)
        };
    });
}

;// CONCATENATED MODULE: ./src/utils/createPageList.js




function createPageList(files, base) {
    return importAll(files).reduce(function(acc, cur) {
        var slug = cur.fileName.substr(2).replace(/\.mdx$/, "");
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, slug, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cur.module.default), {
            href: "/".concat(base, "/").concat(slug)
        })));
    }, {});
}

;// CONCATENATED MODULE: ./src/navs/documentation.js

var pages = createPageList(__webpack_require__(66708), "docs");
var documentationNav = {
    "Getting Started": [
        {
            title: "Setup",
            href: "/docs/setup",
            match: /^\/docs\/setup/
        },
        pages["commerce-definitions"],
        pages["checklist"],
        pages["appcustomisation"],
        pages["testingapp"],
        pages["products"],
        pages["translations"], 
    ],
    "Building Blocks": [
        pages["users"],
        pages["listings"],
        pages["attributes"],
        pages["variants"],
        pages["category"],
        pages["media"],
        pages["review-ratings"],
        pages["location"],
        pages["schedules"],
        pages["search"],
        pages["tags"],
        pages["wishlist"],
        pages["qa-comments"],
        pages["notifications"],
        pages["negotiations"],
        pages["inventory"], 
    ],
    Marketing: [
        pages["collection"],
        pages["promotion"],
        pages["coupon"],
        pages["seo"],
        pages["tracking"], 
    ],
    "Marketplace & Platform": [
        pages["accounts"],
        pages["wallet"],
        pages["chat"],
        pages["social"]
    ],
    "Business Blocks": [
        pages["delivery"],
        pages["paymentgateways"],
        pages["revenuemodel"],
        pages["commission"],
        pages["order"],
        pages["tax"], 
    ],
    "System Blocks": [
        pages["auth"],
        pages["language"],
        pages["currency"],
        pages["email"],
        pages["domain"], 
    ],
    "Editor Guides": [
        pages["template-create"],
        pages["editor-overview"],
        pages["editing-page-styles"],
        pages["dynamic-page"],
        pages["submit-template"], 
    ],
    Deployment: [
        pages["deployment"],
        pages["playstore"],
        pages["appstore"],
        pages["vercel"],
        pages["netlify"], 
    ],
    "Native Integrations": [
        pages["integrations-overview"],
        pages["webhook"],
        pages["zapier"],
        pages["firebase"],
        pages["stripe-payments"],
        pages["stripe-connect"],
        pages["stripe-onboarding"],
        pages["mangopay"],
        pages["onlinepaymentplatform"],
        pages["stuart"],
        pages["branch"],
        pages["google-maps"],
        pages["ga"],
        pages["facebookapp"], 
    ],
    "Solution - UNSDG Goals": [
        pages["crowdfunding"],
        pages["food"],
        pages["education"],
        pages["energy"],
        pages["othersolutions"], 
    ]
};


/***/ }),

/***/ 66708:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./accounts.mdx": 69056,
	"./adding-custom-styles.mdx": 90986,
	"./appcustomisation.mdx": 48317,
	"./appfeatures.mdx": 11260,
	"./appstore.mdx": 35773,
	"./attributes.mdx": 25192,
	"./auth.mdx": 38430,
	"./branch.mdx": 56400,
	"./build-marketplace.mdx": 94485,
	"./category.mdx": 31910,
	"./chat.mdx": 87630,
	"./checklist.mdx": 63113,
	"./cloudflare.mdx": 26716,
	"./collection.mdx": 49128,
	"./commerce-definitions.mdx": 83544,
	"./commission.mdx": 67221,
	"./composer.mdx": 68939,
	"./coupon.mdx": 7000,
	"./crowdfunding.mdx": 37177,
	"./currency.mdx": 37607,
	"./deeplinks.mdx": 48576,
	"./delivery.mdx": 38819,
	"./deployment.mdx": 80390,
	"./domain.mdx": 61798,
	"./dynamic-page.mdx": 56331,
	"./editing-page-styles.mdx": 77659,
	"./editor-overview.mdx": 60285,
	"./education.mdx": 75562,
	"./email.mdx": 14095,
	"./energy.mdx": 37816,
	"./facebookapp.mdx": 21918,
	"./firebase.mdx": 9793,
	"./food.mdx": 30531,
	"./ga.mdx": 96569,
	"./google-maps.mdx": 76536,
	"./growth.mdx": 93959,
	"./integrations-overview.mdx": 62951,
	"./inventory.mdx": 89182,
	"./karix.mdx": 77992,
	"./language.mdx": 89406,
	"./listings.mdx": 11866,
	"./location.mdx": 26787,
	"./mangopay.mdx": 94691,
	"./media.mdx": 79297,
	"./negotiations.mdx": 30293,
	"./netlify.mdx": 53165,
	"./notifications.mdx": 33775,
	"./onlinepaymentplatform.mdx": 84096,
	"./order.mdx": 24521,
	"./othersolutions.mdx": 11906,
	"./paydunya.mdx": 64811,
	"./paymentgateways.mdx": 30688,
	"./playstore.mdx": 41394,
	"./products.mdx": 19904,
	"./promotion.mdx": 38345,
	"./qa-comments.mdx": 61582,
	"./razorpay.mdx": 97405,
	"./render.mdx": 86580,
	"./reports.mdx": 79248,
	"./revenuemodel.mdx": 63676,
	"./review-ratings.mdx": 84053,
	"./schedules.mdx": 93118,
	"./screens.mdx": 5586,
	"./search.mdx": 78533,
	"./seo.mdx": 12137,
	"./setup-app.mdx": 28309,
	"./social.mdx": 23344,
	"./stripe-connect.mdx": 92647,
	"./stripe-onboarding.mdx": 16764,
	"./stripe-payments.mdx": 53402,
	"./stuart.mdx": 6882,
	"./submit-template.mdx": 75493,
	"./subscription.mdx": 69764,
	"./tags.mdx": 40409,
	"./tax.mdx": 27763,
	"./template-create.mdx": 25013,
	"./testingapp.mdx": 48315,
	"./tracking.mdx": 78001,
	"./translations.mdx": 22339,
	"./twilio.mdx": 65268,
	"./users.mdx": 12464,
	"./variants.mdx": 65949,
	"./vercel.mdx": 75005,
	"./wallet.mdx": 99097,
	"./webhook.mdx": 44717,
	"./website.mdx": 67419,
	"./wishlist.mdx": 56012,
	"./zapier.mdx": 72957,
	"src/pages/docs/accounts.mdx": 69056,
	"src/pages/docs/adding-custom-styles.mdx": 90986,
	"src/pages/docs/appcustomisation.mdx": 48317,
	"src/pages/docs/appfeatures.mdx": 11260,
	"src/pages/docs/appstore.mdx": 35773,
	"src/pages/docs/attributes.mdx": 25192,
	"src/pages/docs/auth.mdx": 38430,
	"src/pages/docs/branch.mdx": 56400,
	"src/pages/docs/build-marketplace.mdx": 94485,
	"src/pages/docs/category.mdx": 31910,
	"src/pages/docs/chat.mdx": 87630,
	"src/pages/docs/checklist.mdx": 63113,
	"src/pages/docs/cloudflare.mdx": 26716,
	"src/pages/docs/collection.mdx": 49128,
	"src/pages/docs/commerce-definitions.mdx": 83544,
	"src/pages/docs/commission.mdx": 67221,
	"src/pages/docs/composer.mdx": 68939,
	"src/pages/docs/coupon.mdx": 7000,
	"src/pages/docs/crowdfunding.mdx": 37177,
	"src/pages/docs/currency.mdx": 37607,
	"src/pages/docs/deeplinks.mdx": 48576,
	"src/pages/docs/delivery.mdx": 38819,
	"src/pages/docs/deployment.mdx": 80390,
	"src/pages/docs/domain.mdx": 61798,
	"src/pages/docs/dynamic-page.mdx": 56331,
	"src/pages/docs/editing-page-styles.mdx": 77659,
	"src/pages/docs/editor-overview.mdx": 60285,
	"src/pages/docs/education.mdx": 75562,
	"src/pages/docs/email.mdx": 14095,
	"src/pages/docs/energy.mdx": 37816,
	"src/pages/docs/facebookapp.mdx": 21918,
	"src/pages/docs/firebase.mdx": 9793,
	"src/pages/docs/food.mdx": 30531,
	"src/pages/docs/ga.mdx": 96569,
	"src/pages/docs/google-maps.mdx": 76536,
	"src/pages/docs/growth.mdx": 93959,
	"src/pages/docs/integrations-overview.mdx": 62951,
	"src/pages/docs/inventory.mdx": 89182,
	"src/pages/docs/karix.mdx": 77992,
	"src/pages/docs/language.mdx": 89406,
	"src/pages/docs/listings.mdx": 11866,
	"src/pages/docs/location.mdx": 26787,
	"src/pages/docs/mangopay.mdx": 94691,
	"src/pages/docs/media.mdx": 79297,
	"src/pages/docs/negotiations.mdx": 30293,
	"src/pages/docs/netlify.mdx": 53165,
	"src/pages/docs/notifications.mdx": 33775,
	"src/pages/docs/onlinepaymentplatform.mdx": 84096,
	"src/pages/docs/order.mdx": 24521,
	"src/pages/docs/othersolutions.mdx": 11906,
	"src/pages/docs/paydunya.mdx": 64811,
	"src/pages/docs/paymentgateways.mdx": 30688,
	"src/pages/docs/playstore.mdx": 41394,
	"src/pages/docs/products.mdx": 19904,
	"src/pages/docs/promotion.mdx": 38345,
	"src/pages/docs/qa-comments.mdx": 61582,
	"src/pages/docs/razorpay.mdx": 97405,
	"src/pages/docs/render.mdx": 86580,
	"src/pages/docs/reports.mdx": 79248,
	"src/pages/docs/revenuemodel.mdx": 63676,
	"src/pages/docs/review-ratings.mdx": 84053,
	"src/pages/docs/schedules.mdx": 93118,
	"src/pages/docs/screens.mdx": 5586,
	"src/pages/docs/search.mdx": 78533,
	"src/pages/docs/seo.mdx": 12137,
	"src/pages/docs/setup-app.mdx": 28309,
	"src/pages/docs/social.mdx": 23344,
	"src/pages/docs/stripe-connect.mdx": 92647,
	"src/pages/docs/stripe-onboarding.mdx": 16764,
	"src/pages/docs/stripe-payments.mdx": 53402,
	"src/pages/docs/stuart.mdx": 6882,
	"src/pages/docs/submit-template.mdx": 75493,
	"src/pages/docs/subscription.mdx": 69764,
	"src/pages/docs/tags.mdx": 40409,
	"src/pages/docs/tax.mdx": 27763,
	"src/pages/docs/template-create.mdx": 25013,
	"src/pages/docs/testingapp.mdx": 48315,
	"src/pages/docs/tracking.mdx": 78001,
	"src/pages/docs/translations.mdx": 22339,
	"src/pages/docs/twilio.mdx": 65268,
	"src/pages/docs/users.mdx": 12464,
	"src/pages/docs/variants.mdx": 65949,
	"src/pages/docs/vercel.mdx": 75005,
	"src/pages/docs/wallet.mdx": 99097,
	"src/pages/docs/webhook.mdx": 44717,
	"src/pages/docs/website.mdx": 67419,
	"src/pages/docs/wishlist.mdx": 56012,
	"src/pages/docs/zapier.mdx": 72957
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66708;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [73320,85220,96401,48777,26852,5679,49774,92888,40179], function() { return __webpack_exec__(19582); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);